// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2mCPp","footer":"Form_footer__3J2mV"};